// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"8979822f","282":"e194a52d","345":"01334e41","423":"bab1daa5","511":"1eae3b1d"}[chunkId] + ".chunk.js";
};